import _ from 'lodash';
import * as NW_DEFAULT_TYPES from '@nerdwallet/structured-content/types';
import NW_DEFAULT_SCHEMAS from '@nerdwallet/structured-content/schema';
import NW_DEFAULT_COMPONENTS from '@nerdwallet/structured-content/components';

import * as LPC_TYPES from './types';

/**
 * The name collisions.
 * @type {Array<String>}
 */
const NAME_COLLISIONS = [LPC_TYPES.DIVIDER];

// Alert if any type collisions with `@nerdwallet/structured-content`
/* istanbul ignore next */
_.forEach(LPC_TYPES, (componentName) => {
  if (
    NW_DEFAULT_TYPES[componentName] &&
    !NAME_COLLISIONS.includes(NAME_COLLISIONS)
  ) {
    throw new Error(
      `Structured Content type definition collision on "${componentName}".`
    );
  }
});

/**
 * Sanitized Structured Content component definitions.
 */
export const NW_COMPONENTS = _.omit(NW_DEFAULT_COMPONENTS, NAME_COLLISIONS);

/**
 * Sanitized Structured Content schemas definitions.
 */
export const NW_SCHEMAS = _.omit(NW_DEFAULT_SCHEMAS, NAME_COLLISIONS);
